import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import getBrandUrlWithCategorySlug from "./getBrandUrlWithCategorySlug";
import { useRouteSlug } from "../../../hooks";
import { Brand } from "../../../services/brandsService";
import { SelectedCategory } from "../types";
import "./style.scss";

const Brands: React.FC<{
  groupName: string;
  data: Brand[];
  selectedCategory: SelectedCategory;
}> = ({ groupName, data, selectedCategory }) => {
  const routeSlug = useRouteSlug();

  return (
    <div className="brands">
      <div className="brands-header" id={`section${groupName}`}>
        {!isEmpty(data) && (
          <p>
            {groupName} <span>({data.length})</span>
          </p>
        )}
      </div>
      <ul className="brands-list-wrapper">
        {map(data, brand => (
          <li key={brand.brand.value + brand.category.value}>
            <Link
              to={`/${routeSlug}${getBrandUrlWithCategorySlug(
                brand,
                selectedCategory.slug
              )}`}
              className="brands-list-text"
            >
              {brand.brand.value}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Brands;
